import { defineStore } from 'pinia';
import type { 
  ICirrusSyncMediaPlaybackStateData
} from '../shared/CirrusReaderModel';

interface CirrusMediaPlayerState {
  isPlayerAttached: boolean;
  playbackState?: ICirrusSyncMediaPlaybackStateData;
  lastUpdated: number | null;
}

export const useCirrusMediaPlayerStore = defineStore('cirrusMediaPlayer', {
  state: (): CirrusMediaPlayerState => ({
    isPlayerAttached: false,
    playbackState: undefined,
    lastUpdated: null,
  }),
  actions: {
    setPlayerAttached(value: boolean) {
      this.isPlayerAttached = value;
    },
    setPlaybackState(playbackState: ICirrusSyncMediaPlaybackStateData) {
      console.log("Setting playback state", playbackState.text);
      this.playbackState = playbackState;
      this.lastUpdated = Date.now();
    },
    clearPlaybackState() {
      this.playbackState = undefined;
      this.lastUpdated = null;
    }
  },
});
